module.exports = __webpack_public_path__ + "img/VideoTitleNavigation.fe4a0a96.png";